export { useDigitalCompetencyListener } from "./hooks/useDigitalCompetencyListener";
